var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManage = function SvgManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.034 6H3.667a1.667 1.667 0 1 1 0-3.333h6.367M5.966 13.333h6.367a1.667 1.667 0 1 0 0-3.333H5.966M2 11.667a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0m12-7.334a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0"
  })));
};
export default SvgManage;